export enum SuggestedGcpType {
  ADD_NEW = 'ADD_NEW',
  SEND_COORDINATES = 'SEND_COORDINATES',
}
